// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".groupActiveCodeStatistics-container .list[data-v-5c7a377b] {\n  display: flex;\n  margin-top: 8px;\n}\n.groupActiveCodeStatistics-container .list .item[data-v-5c7a377b] {\n    margin-right: 40px;\n}\n.groupActiveCodeStatistics-container .title[data-v-5c7a377b] {\n  margin-top: 10px;\n  font-weight: bold;\n}\n.groupActiveCodeStatistics-container .staff-pagination[data-v-5c7a377b] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  height: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
